import { ScrollArea } from "@base-ui/react/scroll-area"
import React from "react"

import { useRovingTabIndex } from "shared/lib/useRovingTabIndex"
import { Direction } from "shared/types/Direction"
import { RovingTabIndexItem } from "shared/types/RovingTabIndex"
import { WithID } from "shared/types/WithID"

import "./styles/_building-reference-list.scss"

export interface GenericBuildingReferenceListItemType<
  ElementType extends HTMLElement
> extends WithID,
    RovingTabIndexItem<ElementType> {}

export interface BuildingReferenceListViewModel<
  ElementType extends HTMLElement,
  T extends GenericBuildingReferenceListItemType<ElementType>
> {
  items: T[]
  ItemRenderer: React.ComponentType<T>
}

function BuildingReferenceListComponent<
  ElementType extends HTMLElement,
  T extends WithID
>({ items, ItemRenderer }: BuildingReferenceListViewModel<ElementType, T>) {
  const { containerProps, getElementProps } = useRovingTabIndex({
    elementCount: items.length,
    direction: Direction.HORIZONTAL,
    disableRovingTabIndex: true
  })

  return (
    <ScrollArea.Root
      {...containerProps}
      className="scroll-area scroll-area--horizontal shadow-m"
    >
      <ScrollArea.Viewport className="scroll-area__viewport">
        <ScrollArea.Content className="scroll-area__content building-reference-list">
          {items?.map((item, index) => (
            <ItemRenderer key={item.id} {...item} {...getElementProps(index)} />
          ))}
        </ScrollArea.Content>
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar
        orientation="horizontal"
        className="scroll-area__scrollbar"
      >
        <ScrollArea.Thumb className="scroll-area__thumb" />
      </ScrollArea.Scrollbar>
    </ScrollArea.Root>
  )
}

export const BuildingReferenceList = React.memo(
  BuildingReferenceListComponent
) as typeof BuildingReferenceListComponent
